module.exports = __webpack_public_path__ + "static/media/1p.9a08fb02.png";